import { useFormState, useWatch, type Control } from 'react-hook-form';

import type { ReceiveConvoyFormValues } from './types';

/**
 * One line's slice of the form — its values and its errors. Every cell of the
 * row subscribes on its own, so typing re-renders that row's cells alone,
 * never the whole table (a convoy easily has dozens of lines).
 */
export const useConvoyLine = (control: Control<ReceiveConvoyFormValues>, shipmentIndex: number, lineIndex: number) => {
  const name = `shipments.${shipmentIndex}.lines.${lineIndex}` as const;
  const values = useWatch({ control, name });
  const { errors } = useFormState({ control, name });
  return { name, values, errors: errors.shipments?.[shipmentIndex]?.lines?.[lineIndex] };
};
